import React, { useState, memo } from 'react'
import { withTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride'
import WelcomeTutorial from './WelcomeTutorial';
import TourTooltip from './TourTooltip';
import RouterPath from 'libs/RouterPath';
import steps from './tutorial.steps'
import { connect } from 'react-redux'
import { setOpenTutorial } from 'redux/actions'

function Tutorial({
	theme,
	openTutorial,
	setOpenTutorial
}) {
	const [step, setStep] = useState(0)
	const [run, setRun] = useState(false);

	const handleWelcomeClick = () => {
		RouterPath.redirect(RouterPath.TEST)
		setOpenTutorial(false)
		setRun(true)
	}

	const handleEndTour = () => {
		setRun(false)
	}

	const handleJoyrideCallback = ({ action, index, status, type }) => {
		if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
			// Update state to advance the tour
			setStep(index + (action === ACTIONS.PREV ? -1 : 1))
		}
		else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
			// Need to set our running state to false, so we can restart if we click start again.
			setRun(false)
		}else if([STATUS.PAUSED].includes(status)){
			setStep(0)
		}
	}
	
	return (
		<>
			<WelcomeTutorial open={openTutorial} onClick={handleWelcomeClick} />
			<Joyride
				callback={handleJoyrideCallback}
				run={run}
				tooltipComponent={(props) =>
					<TourTooltip
						{...props}
						onEnd={handleEndTour}
					/>}
				stepIndex={step}
				disableOverlayClose
				continuous
				steps={steps}
				styles={{
					options: {
						zIndex: theme.zIndex.tooltip,
					}
				}}
			/>
		</>
	)
}

Tutorial.propTypes = {
	classes: PropTypes.any,
}

Tutorial.defaultProps = {
}

export default connect((state) => ({
	openTutorial: state.store.openTutorial,
}), {
	setOpenTutorial
})(memo(withTheme(Tutorial)));